import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M23 18.25h-2.33a3.1 3.1 0 0 0 .46-1.06h1.37a.74.74 0 0 0 .57-.27.71.71 0 0 0 .17-.61l-.56-3.26a3.68 3.68 0 0 0-3.29-3.12l-3.28-.25L14.35 7a.75.75 0 0 0-1.25.83l1.11 1.67-3.49-.28a2.75 2.75 0 1 0-5-1.61c.004.435.11.863.31 1.25l-.81-.06V7.64a.75.75 0 0 0-1.5 0v1.07h-.11a2.54 2.54 0 0 0-2 .69 2.85 2.85 0 0 0-.9 2.08V16a.75.75 0 0 0 .61.74l1.68.33c.08.423.246.825.49 1.18H1a.75.75 0 1 0 0 1.5h22a.75.75 0 1 0 0-1.5M8.5 6.39a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m7.72 10.05A1.75 1.75 0 1 1 18 18.19a1.76 1.76 0 0 1-1.78-1.75m-14-5a1.3 1.3 0 0 1 .42-1 1.07 1.07 0 0 1 .82-.3l15.79 1.24a2.17 2.17 0 0 1 1.95 1.92l.41 2.39h-.48a3.24 3.24 0 0 0-6.38.5H9.44a3.23 3.23 0 0 0-6.34-.63l-.85-.17zm5.71 5a1.75 1.75 0 1 1-1.75-1.75A1.75 1.75 0 0 1 8 16.44zm1.25 1.25H15q.117.298.3.56H8.91q.182-.262.3-.56z" />
  </>
);

const ScenicDriving = Icon('scenic-driving', svgContents);

export default ScenicDriving;
